module.exports = __webpack_public_path__ + "static/media/picked.59758eeb.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/picked.svg
// module id = ./src/assets/icons/picked.svg
// module chunks = 0